import { useMemo } from 'react'
import useMedia from './useMedia'


const mediaTypesMap = {
  isDesktop: 'desktop',
  isMobile: 'mobile',
  isTablet: 'tablet',
  isTabletPortrait: 'tabletPortrait',
  isTabletLandscape: 'tabletLandscape',

  isExceptDesktop: 'exceptDesktop',
  isExceptMobile: 'exceptMobile',
  isTabletLandscapeAndHigher: 'tabletLandscapeAndHigher',
  isTabletLandscapeAndLower: 'tabletLandscapeAndLower',
  isTabletPortraitAndHigher: 'tabletPortraitAndHigher',
  isTabletPortraitAndLower: 'tabletPortraitAndLower',
}

const mediaTypesMapKeys = Object.keys(mediaTypesMap)

const useMediaTypes = () => {
  const mediaFlags = useMedia()

  return useMemo(() => (
    mediaTypesMapKeys.reduce((result, key) => {
      result[mediaTypesMap[key]] = mediaFlags[key]

      return result
    }, {})
  ), [ mediaFlags ])
}


export default useMediaTypes
